import { defineMessage } from 'services/localization';

export const messages = {
    successfulMessage: defineMessage('has_been_successfully_copied_to'),
    successfulNumber: defineMessage('number_workflows'),
    settingsErrorHeader: defineMessage('the_copy_of_the_workflo_the_following_workflows'),
    matrixErrorHeader: defineMessage('the_copy_of_the_workflo_the_following_workflows_1'),
    activateWorkflow: defineMessage('note_dont_forget_to_activate_your_workflow'),
    done: defineMessage('done'),
};
